import React, { useEffect, useState } from "react";
import { Button, Stack } from "@mui/material";
import { Loader } from "components/Loader";
import { RequestInfoBanner } from "components/DesignSystem/RequestInfoBanner";
import { designColors, designWeights } from "services/constants/designTokens";
import { PayInputAuditTrail } from "./AuditTrail";
import { isSavedPayInputId, loadPayInputActivity } from "./payInputActivity";

export const PayInputActivityLog = (props) => (
  <ActivityLogContent key={`${props.domain}:${props.type}:${props.recordId}:${props.refreshKey || ""}`} {...props} />
);

const ActivityLogContent = ({ domain, type, recordId }) => {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [retry, setRetry] = useState(0);
  const saved = isSavedPayInputId(recordId);
  useEffect(() => {
    if (!saved) return;
    const controller = new AbortController();
    setLoading(true); setError(""); setEntries([]);
    loadPayInputActivity(domain, type, recordId, { signal: controller.signal })
      .then((data) => { if (!controller.signal.aborted) setEntries(data); })
      .catch((e) => { if (!controller.signal.aborted) setError(e.message); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [domain, type, recordId, saved, retry]);

  if (!saved) return <RequestInfoBanner title="Activity Log" body="Activity is available for saved records only." />;
  if (loading) return <Loader info="Loading..." minHeight="30vh" />;
  if (error) return (
    <Stack spacing={1.5} alignItems="flex-start">
      <RequestInfoBanner tone="danger" title="Could not load the activity log" body={error} />
      <Button onClick={() => setRetry((n) => n + 1)} sx={{ textTransform: "none", fontWeight: designWeights.semibold, color: designColors.tealDark }}>Retry</Button>
    </Stack>
  );
  return <PayInputAuditTrail entries={entries} />;
};
